import type { Transaction, TransactionAttachment } from '@shared/transactions-types';
import { createMutation } from '@luna/api';
import { logger } from '@luna/logger';
import { t } from '@luna/i18n';

import { escapeFileName } from './escapeFileName';
import { getAttachmentUrl } from './getAttachmentUrl';
import { validateFile } from './validateFile';
import { updateTransactionCache } from '../list/PaginatedTransactions';
import { uploadRequest } from '../FileUploadService';

interface Props {
    transaction: Transaction;
    file: File;
    onProgress?: (event: ProgressEvent) => void;
}

export const [useSaveAttachment] = createMutation({
    name: 'transactions/saveAttachment',
    cache: false,
    payloadCreator: ({ transaction, file, onProgress }: Props): Promise<Transaction> => {
        validateFile(file);

        const url = getAttachmentUrl(transaction.id);
        const headers = { 'Content-Type': null };
        const formData = new FormData();
        formData.append('file', file, escapeFileName(file.name));

        return uploadRequest<TransactionAttachment>({ url, headers, formData, onProgress })
            .then((attachment) => {
                const updatedTransaction: Transaction = { ...transaction, attachment };
                updateTransactionCache(updatedTransaction);
                return updatedTransaction;
            })
            .catch((error) => {
                logger.error(error);
                throw new Error(t('transaction.attachment.saveError'));
            });
    },
});
